/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessSourceStat
 */
export interface BusinessSourceStat {
    /**
     * 业务类型名称
     * @type {string}
     * @memberof BusinessSourceStat
     */
    typeName?: string;
    /**
     * 代买订单数量
     * @type {number}
     * @memberof BusinessSourceStat
     */
    buyingCount?: number;
    /**
     * 转运订单数量
     * @type {number}
     * @memberof BusinessSourceStat
     */
    transferCount?: number;
    /**
     * 代买占比(%)
     * @type {number}
     * @memberof BusinessSourceStat
     */
    buyingPercentage?: number;
    /**
     * 转运占比(%)
     * @type {number}
     * @memberof BusinessSourceStat
     */
    transferPercentage?: number;
    /**
     * 合计
     * @type {number}
     * @memberof BusinessSourceStat
     */
    total?: number;
}

/**
 * Check if a given object implements the BusinessSourceStat interface.
 */
export function instanceOfBusinessSourceStat(value: object): value is BusinessSourceStat {
    return true;
}

export function BusinessSourceStatFromJSON(json: any): BusinessSourceStat {
    return BusinessSourceStatFromJSONTyped(json, false);
}

export function BusinessSourceStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessSourceStat {
    if (json == null) {
        return json;
    }
    return {
        
        'typeName': json['typeName'] == null ? undefined : json['typeName'],
        'buyingCount': json['buyingCount'] == null ? undefined : json['buyingCount'],
        'transferCount': json['transferCount'] == null ? undefined : json['transferCount'],
        'buyingPercentage': json['buyingPercentage'] == null ? undefined : json['buyingPercentage'],
        'transferPercentage': json['transferPercentage'] == null ? undefined : json['transferPercentage'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function BusinessSourceStatToJSON(json: any): BusinessSourceStat {
    return BusinessSourceStatToJSONTyped(json, false);
}

export function BusinessSourceStatToJSONTyped(value?: BusinessSourceStat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'typeName': value['typeName'],
        'buyingCount': value['buyingCount'],
        'transferCount': value['transferCount'],
        'buyingPercentage': value['buyingPercentage'],
        'transferPercentage': value['transferPercentage'],
        'total': value['total'],
    };
}

